<owl-carousel-o [options]="customOptions">
    <ng-template carouselSlide *ngFor="let sector of sectores">
        hola
        <div class="box">
            <div class="slide-img">
                <img alt="1" src="assets/img/barrios/{{ sector.imageUrl }}">
                <div class="overlay" style="background-image: url(assets/img/barrios/{{sector.codigo}}-overlay.png); background-size: cover;">
                    <a routerLink="/sectorgchc/{{ sector.codigo }}" class="buy-btn">ver más</a>
                </div>
            </div>
            <div class="detail-box">
                <div class="type">
                    <a><span class="mini-title">Barrio de <br></span>{{sector.sector}}</a>
                    <span class="cod-title">{{sector.codigo}}</span>
                </div>
            </div>
        </div>
    </ng-template>
</owl-carousel-o>